import styles from "./HomePage.module.css";
import { useState, useContext } from "react";

import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/auth.context";
import authService from "../../services/auth.service";

function HomePage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const { authenticateUser, setIsLoading } = useContext(AuthContext);

  const _handleLoginSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsLoading(true);
    authService
      .login({ email, password })
      .then(({ data }) => {
        localStorage.setItem("authToken", data.authToken);
        if (data.refreshToken) {
          localStorage.setItem("refreshToken", data.refreshToken);
        }
        authenticateUser();
        navigate("/dashboard");
      })
      .catch((e) => {
        setErrorMessage(e.response.data.errorMessages[0]);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className={styles["login-page"]}>
      <div className={styles["login-container"]}>
        <img className={styles.logo} src="./logo.png" alt="Logo" />
        <h2>Iniciar Sesión</h2>
        <p className={styles["login-subtitle"]}>Administración y seguimiento del grupo</p>
        <form className={styles["login-form"]} onSubmit={_handleLoginSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            name="contrasena"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <p className={styles["login-error-message"]}>{errorMessage}</p>
          <button type="submit">Iniciar Sesión</button>
        </form>
        <button
          className={styles.fixedButton}
          onClick={() => navigate("/patrolmeter")}
        >
          Patrullometro
        </button>
      </div>
    </div>
  );
}

export default HomePage;
